module.exports = __webpack_public_path__ + "img/comm-server.61f97241.svg";